
































import {Prop, Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import {Widget, WidgetParameters} from "@/components/dashboard/Dashboard.vue";
import Container from "@/components/dashboard/widgets/Container.vue";
import _ from "lodash";

interface Style {
    [property: string]: string | number;
}

const components = {
    Container,
};

interface ImageLinkParameters extends WidgetParameters {
    imageUrl?: string;
    logo?: string;
    cta?: {
        label: string;
        url?: string;
        route?: string;
        disabled: boolean;
    };
}

interface ImageLinkData extends Widget {
    parameters: ImageLinkParameters;
}

@Component({components})

export default class ImageContainer extends Vue {
    @Prop({default: null}) public widget!: ImageLinkData;

    protected get hasCta(): boolean {
        return this.isUrlLink || this.isRouteLink;
    }

    protected get isUrlLink(): boolean {
        return !!this.widget.parameters?.cta?.url;
    }

    protected get isRouteLink(): boolean {
        return !!this.widget.parameters?.cta?.route;
    }

    protected get containerStyle(): Style {
        return {
            padding: 0,
        };
    }

    protected get titleStyle(): Style {
        return _.get(this.widget.parameters, "style.title", {});
    }

    protected goToCta(): void {
        if (this.isUrlLink && this.widget?.parameters?.cta?.url) {
            window.open(this.widget.parameters.cta.url, "_blank");
        } else if (this.isRouteLink && this.widget?.parameters?.cta?.route) {
            this.$router.push(this.widget.parameters.cta.route);
        }
    }
}
